// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"119":"8d1ce28e","2487":"8d1ce28e","4096":"8d1ce28e","5281":"8d1ce28e","5614":"8d1ce28e","6346":"8d1ce28e","9640":"0dfc1d9c"}[chunkId] + ".chunk.css";
};